import { PinTab } from "./PinTab";

export default PinTab;